import { downloadFiles } from '@/utils/client/fileHelper';
import { Button, Flex } from 'antd';
import axios from 'axios';
import { useContext } from 'react';
import { LibraryContext } from './context-provider';

export default function LibraryActionBar() {
   const { shared, selectedLibrary, setDeleteModalOpen, setRenameModalOpen, setMoveModalOpen, setShareModalOpen , setSelectedLibrary } =
      useContext(LibraryContext);

   if (!selectedLibrary || selectedLibrary.length === 0) return null;

   async function handleDownload() {
      // get signed urls for all files
      const urls = await axios.get('/api/library/download', {
         params: {
            files: selectedLibrary
               .filter((item) => item.type === 'file')
               .map((item) => item._id)
               .join(','),
         },
      });
      // download files using signed urls
      downloadFiles(urls.data.urls);
   }

   return (
      <>
         <Flex gap={32} align="center">
            <Flex gap={16} align="center">
               {selectedLibrary?.filter((item) => item.type === 'folder').length === 0 && (
                  <Button
                     size="small"
                     type="text"
                     icon={<i className="fi fi-rr-download" />}
                     onClick={() => handleDownload()}
                  >
                     Download
                  </Button>
               )}
               {!shared && (
                  <>
                     <Button
                        size="small"
                        type="text"
                        icon={<i className="fi fi-rr-trash" />}
                        onClick={() => setDeleteModalOpen(true)}
                     >
                        Delete
                     </Button>
                     {
                        // if only one item is selected
                        selectedLibrary?.length === 1 && (
                           <Button
                              size="small"
                              type="text"
                              icon={<i className="fi fi-rr-share" />}
                              onClick={() => setShareModalOpen(true)}
                           >
                              Share
                           </Button>
                        )
                     }
                     <Button
                        size="small"
                        type="text"
                        icon={<i className="fi fi-rr-move-to-folder" />}
                        onClick={() => setMoveModalOpen(true)}
                     >
                        Move
                     </Button>
                     {selectedLibrary?.length === 1 && (
                        <Button
                           size="small"
                           type="text"
                           icon={<i className="fi fi-rr-pen-square" />}
                           onClick={() => setRenameModalOpen(true)}
                        >
                           Rename
                        </Button>
                     )}
                  </>
               )}
            </Flex>
            <Button type="dashed" icon={<i className="fi fi-rr-arrow-left" />} onClick={()=>{
               setSelectedLibrary([])
            }}>
               {selectedLibrary?.length} selected
            </Button>
         </Flex>
      </>
   );
}
